export default __webpack_public_path__ + "static/media/andes_a_la_selva_4.f6e43d0c.JPG";